<template>
  <div
      class="g-signin2"
      v-if="!loading"
      @click="handleAuthorizeButtonClick"
      :title="(isSignedIn && 'Sign out') || 'Sign in with Google'"
  >
    <div class="img-ctn">
      <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          width="18px"
          height="18px"
          viewBox="0 0 48 48"
          class="abcRioButtonSvg"
      >
        <g>
          <path
              fill="#EA4335"
              d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
          ></path>
          <path
              fill="#4285F4"
              d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
          ></path>
          <path
              fill="#FBBC05"
              d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
          ></path>
          <path
              fill="#34A853"
              d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
          ></path>
          <path fill="none" d="M0 0h48v48H0z"></path>
        </g>
      </svg>
    </div>
    <div class="text">
      {{ get_authorize_text }}
    </div>
  </div>
  <!--  <button @click="login">Login Using Google</button>-->
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import {check_auth, initialize, logout, server_login, login, fetchMessages} from '../../modules/emails/gmail_api'
import {googleSdkLoaded} from "vue3-google-login";

export default {
  components: {},
  computed: {
    ...mapGetters([
      'emails_gapi',
      'emails_is_signed_in',
    ]),
    get_authorize_text() {
      return this.isSignedIn && 'Sign out' || 'Sign in with Google'
    },

  },
  data() {
    return {
      isSignedIn: false,
      loading: false,
    }
  },
  methods: {
    ...mapActions([
      'emails_set_gapi',
      'emails_set_is_signed_in',
      'emails_set_profile',
    ]),
    handleAuthorizeButtonClick() {
      if (!this.isSignedIn) {
        this.loading = false
        server_login()
      } else {
        logout()
      }
    },
    decodeJwt(token) {
      let base64Payload = token.split(".")[1];
      let payloadBuffer = Buffer.from(base64Payload, "base64");
      return JSON.parse(payloadBuffer.toString());
    },

    // login(){
    //   googleSdkLoaded((google) => {
    //     // google.accounts.id.initialize({
    //     //   client_id: window.Laravel.env.EMAILS.EMAILS_GMAIL_CLIENT_ID,
    //     //   ux_mode: "popup",
    //     //   callback: (response) => {
    //     //       console.log("Handle the response", typeof response.credential)
    //     //     let klk = this.decodeJwt(response.credential)
    //     //     console.log(klk, response)
    //     //     }
    //     // })
    //     // google.accounts.id.prompt();
    //
    //     google.accounts.oauth2.initTokenClient({
    //       client_id: window.Laravel.env.EMAILS.EMAILS_GMAIL_CLIENT_ID,
    //       scope: "https://www.googleapis.com/auth/gmail.readonly https://www.googleapis.com/auth/gmail.labels https://www.googleapis.com/auth/contacts https://www.googleapis.com/auth/contacts.readonly https://www.googleapis.com/auth/gmail.modify",
    //       callback: (response) => {
    //         window.localStorage.setItem("GMAIL_SESSION", JSON.stringify(response))
    //       }
    //     }).requestAccessToken()
    //   })
    // },
    onSignIn() {
      check_auth()
          .then((value) => {
            this.emails_set_profile(value.data)
            this.emails_set_is_signed_in(true)
          })
          .catch((err) => {
            console.log(err)
          })
    },
    /**
     *  Called when the signed in status changes, to update the UI
     *  appropriately. After a sign-in, the API is called.
     */
    updateSigninStatus(isSignedIn) {
      this.isSignedIn = isSignedIn
      this.$emit('updateSigninStatus', isSignedIn)
      this.onSignIn()
    },
  },
  mounted() {
    this.onSignIn()

  },
}
</script>

<style lang="sass">
.g-signin2
  align-items: center
  background: white
  border-radius: 5px
  border: thin solid #dbdbdb
  box-shadow: 1px 1px 1px grey
  color: #444
  display: flex
  height: 36px
  white-space: nowrap
  width: 200px

  &:hover
    cursor: pointer

  .img-ctn
    align-items: center
    display: flex
    flex-direction: row
    flex-wrap: nowrap
    height: 36px
    justify-content: center
    width: 36px

  .text
    display: inline-block
    flex: 1
    font-family: 'Roboto', sans-serif
    font-size: 14px
    font-weight: bold
    text-align: center
</style>